import React from 'react';

export interface HeaderLumirAppendixProps {
  appendixNumber: string;
  mainContractNumber?: string;
  mainContractDate?: string;
  logoSrc?: string;
}

// Helper component for blank underline
const BlankField: React.FC<{ width?: string }> = ({ width = 'w-32' }) => (
  <span className={`inline-block border-b border-gray-900 ${width} h-px ml-1 translate-y-[-2px]`}></span>
);

const HeaderLumirAppendix: React.FC<HeaderLumirAppendixProps> = ({
  appendixNumber,
  mainContractNumber,
  mainContractDate,
  logoSrc = '/images/logo/logoweb.webp',
}) => {
  return (
    <>
      {/* Header Block */}
      <div className="pdf-block !relative !mb-10 !pt-4" style={{ minHeight: '120px' }}>
        <div className="!absolute !top-0 !left-0 !w-20 pdf-logo">
          <img
            src={logoSrc}
            alt="BeQ Holdings Logo"
            className="!w-16 !h-16 !object-contain"
          />
        </div>

        <div className="text-center">
          <p className="!text-[12px] !font-bold !uppercase !m-0" style={{ color: '#000' }}>
            CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
          </p>
          <p className="!text-[11px] !m-0" style={{ color: '#000' }}>
            Độc lập – Tự do – Hạnh phúc
          </p>
          <div className="!w-24 !h-[1px] !bg-black !mx-auto !mt-1 !mb-4"></div>

          <h1 className="!text-lg !font-bold !uppercase !mt-6" style={{ color: '#000' }}>
            PHỤ LỤC 01
          </h1>
          <p className="!text-sm !mt-2">
            Kèm theo Hợp đồng Hợp tác đầu tư Dự án LUMIR và CCPI
          </p>
          <p className="!text-sm">
            Số: {mainContractNumber || <BlankField width="w-24" />} ngày {mainContractDate || <BlankField width="w-20" />}
          </p>
        </div>
      </div>
    </>
  );
};

export default HeaderLumirAppendix;
